import { ArrowUpRight, Sparkles, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";

export default function NextMoveCard({ nextMove, referralLink }) {
  if (!nextMove) return null;

  return (
    <div
      className="relative overflow-hidden rounded-2xl p-6 md:p-8 transition-all duration-300 h-full flex flex-col justify-between"
      style={{
        background: 'linear-gradient(145deg, rgba(59,130,246,0.08) 0%, rgba(124,58,237,0.06) 50%, rgba(11,13,23,0.95) 100%)',
        border: '1px solid rgba(99, 102, 241, 0.12)',
      }}
      data-testid="next-move-card"
    >
      {/* Subtle glow in corner */}
      <div
        className="absolute -top-12 -right-12 w-32 h-32 rounded-full opacity-20 blur-2xl"
        style={{ background: 'radial-gradient(circle, rgba(99,102,241,0.5), transparent 70%)' }}
      />

      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-4">
          <Sparkles className="w-4 h-4 text-purple-400" />
          <p className="text-xs font-medium text-purple-400/80 uppercase tracking-[0.15em]">
            The Next Move
          </p>
        </div>

        <h3
          className="font-heading font-bold text-2xl text-white tracking-tight mb-2"
          data-testid="next-move-card-name"
        >
          {nextMove.card_name}
        </h3>

        <p
          className="text-sm text-white/40 leading-relaxed mb-5"
          data-testid="next-move-why"
        >
          {nextMove.why}
        </p>

        <span
          className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-semibold mb-6"
          style={{
            background: 'rgba(16, 185, 129, 0.1)',
            color: '#34d399',
            border: '1px solid rgba(16, 185, 129, 0.15)',
          }}
          data-testid="next-move-gain"
        >
          <ArrowUpRight className="w-3.5 h-3.5" />
          {nextMove.potential_gain}
        </span>
      </div>

      {/* THE ACTION BUTTON */}
      {referralLink ? (
        <motion.a
          href={referralLink}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="relative z-10 w-full py-3.5 bg-white text-black font-black rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg hover:shadow-white/10 mt-auto"
        >
          Apply & Claim Rewards
          <ExternalLink className="w-4 h-4" />
        </motion.a>
      ) : (
        <div className="relative z-10 w-full py-3.5 bg-white/5 border border-white/10 text-white/20 font-bold rounded-xl text-center text-[10px] uppercase tracking-widest mt-auto">
          Coming Soon
        </div>
      )}
    </div>
  );
}
